import React, {useState} from 'react'
import {  
  CModal,
  CModalBody,  
  CModalHeader,
  CModalTitle,    
  CSpinner 
} from '@coreui/react'
import {setOnLoad} from '../../Manager'

const ModalLoading = (props) => {

  const [loading, setLoading] = useState(false)  
  
  const onLoad = (load) =>{        
    if (load) {
      setLoading(true)
    } else {      
      setLoading(false)
    }
  }  
  
  setOnLoad(onLoad)
  
  return (
    <CModal alignment="center" visible={loading} backdrop={false} keyboard={false} >
        <CModalHeader>
          <CModalTitle>Attendere Prego...</CModalTitle>
        </CModalHeader>
        <CModalBody className="d-flex justify-content-center">          
          <CSpinner className="m-5"></CSpinner>            
        </CModalBody>        
      </CModal>
  )
}

export {ModalLoading}
